import { faCircleCheck, faTriangleExclamation, faXmark, IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { SCloseIcon, SContent, SIcon, SWrapper } from './styles/Toasts.styled';

/** Scopes BC toasts to this container so they are not duplicated when StudioMenu mounts its own ToastContainer. */
export const bcToastContainerId = 'bc-toasts';

interface IToastContainerProps {
  content: string | React.ReactNode;
  icon: IconDefinition;
  id: string;
}

export const ToastContainer: React.FC<IToastContainerProps> = ({ icon, content, id }) => {
  return (
    <SWrapper id={id}>
      <SIcon>
        <FontAwesomeIcon icon={icon} />
      </SIcon>
      <SContent>{content}</SContent>
      <SCloseIcon>
        <FontAwesomeIcon icon={faXmark} />
      </SCloseIcon>
    </SWrapper>
  );
};

interface ICustomToastProps {
  content: string | React.ReactNode;
  type: 'error' | 'warn' | 'success' | 'info';
  autoClose?: boolean;
  isAuth?: boolean;
  id: string | number;
  dismissOnNavigation?: boolean;
  allowDuplicates?: boolean;
}

interface IUpdateToastProps {
  id: string | number;
  content: string | React.ReactNode;
}

export function customToast({
  content,
  type,
  isAuth = false,
  autoClose = true,
  id,
  dismissOnNavigation = false,
  allowDuplicates = false,
}: ICustomToastProps) {
  const autoCloseTiming = type === 'error' ? 7500 : undefined;
  const commonOptions: ToastOptions = {
    icon: false,
    closeButton: false,
    closeOnClick: true,
    draggable: false,
    position: isAuth ? 'top-center' : 'top-right',
    toastId: allowDuplicates ? Math.random() : id,
    autoClose: autoClose ? autoCloseTiming : false,
    containerId: bcToastContainerId,
  };

  if (dismissOnNavigation) toastsToDismissOnNavigation.push(id);

  switch (type) {
    case 'error':
      return toast.error(<ToastContainer icon={faTriangleExclamation} content={content} id={id.toString()} />, {
        ...commonOptions,
      });
    case 'info':
      return toast.info(<ToastContainer icon={faTriangleExclamation} content={content} id={id.toString()} />, {
        ...commonOptions,
      });
    case 'success':
      return toast.success(<ToastContainer icon={faCircleCheck} content={content} id={id.toString()} />, {
        ...commonOptions,
      });
    case 'warn':
      return toast.warn(<ToastContainer icon={faTriangleExclamation} content={content} id={id.toString()} />, {
        ...commonOptions,
      });
  }
}

export function updateToast({ id, content }: IUpdateToastProps) {
  return toast.update(id, {
    render: <ToastContainer icon={faTriangleExclamation} content={content} id={id.toString()} />,
    containerId: bcToastContainerId,
  });
}

export const checkAndDismissToast = (id: string) => {
  if (toast.isActive(id)) {
    toast.dismiss(id);
  }
};

export const checkAndDismissToasts = (...ids: string[]): void => {
  if (ids.length) {
    ids.forEach((id) => checkAndDismissToast(id));
  }
};

export enum toastIds {
  vantageQueries = 'tstSysPrinWoVqueriesMessage',
  error = 'mdlError',
  messageDetails = 'tstDisplayMessageErrors',
  department = 'tstDepartmentError',
}

export const toastsToDismissOnNavigation: Array<string | number> = [];
